import * as React from "react";

const ClockDollerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Clock Circle: Ends exactly where the dollar sign sits, keeping the silhouette round */}
    <path
      d="M19.8 9.5A9 9 0 1 0 12.6 19.9"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Clock Hands: Hour hand to 12 o'clock, and minute hand to 4 o'clock */}
    <path
      d="M11 6V11L13 12"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Dollar Sign: Shifted up to Y=12-20 to align perfectly with the clock circle bottom */}
    <path
      d="M15.6 17.6C15.6 18.5 16.3 19.2 17.2 19.2H18.8C19.7 19.2 20.4 18.5 20.4 17.6C20.4 16.7 19.7 16 18.8 16H17.2C16.3 16 15.6 15.3 15.6 14.4C15.6 13.5 16.3 12.8 17.2 12.8H18.8C19.7 12.8 20.4 13.5 20.4 14.4M18 12V20"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ClockDollerIcon;
